export enum AdditionalColumnRequirementRelationType {
  all = 'all',
  selected = 'selected',
}
